import React, { Component } from 'react';
import {Facebook} from '../../layout/icons/facebook';
import {Twitter} from '../../layout/icons/twitter';
import {GooglePlus} from '../../layout/icons/google-plus';
import {Instagram} from '../../layout/icons/instagram';

const SocialFollow = props => {

  const socialLinks = props.socialLinks || {};

  const socialComponentMap = {
    'facebook':  Facebook,
    'twitter': Twitter,
    'google': GooglePlus,
    'instagram': Instagram,
  };

  const proxyHandler = {
    get : (obj, prop) => prop in obj ? obj[prop] : null
  };


  const socialComponentMapProxy = new Proxy(socialComponentMap, proxyHandler);

  const socialComponents = Object.keys(socialLinks).map((socialLink, index) => {
    let componentName = '';
    let link = '#';
    if(socialLink.search('-') !== -1 && socialLinks[socialLink]){
      componentName = socialLink.split('-')[0].toLowerCase();
      link = socialLinks[socialLink];
    }
    const SocialFollowComponent = socialComponentMapProxy[componentName];

    const { width,
      height,
      backgroundColor,
      border,
      color,
      primaryColor,
      hasBackground,
      className = '' } = props;

    return (
      !SocialFollowComponent ? SocialFollowComponent :
        <li className={`social-link ${className}`} key={`social-component-${index}`}>
          <SocialFollowComponent
            link={link}
            width={width}
            height={height}
            color={color}
            hasBackground={hasBackground}
            backgroundColor={backgroundColor}
            border={border}
          />
        </li>
    )
  });

  return (
    <ul className='social-links'>
      {socialComponents}
    </ul>
  )
};

export { SocialFollow };